<div class="container-fluid px-3">
  <ng-container *ngIf="showListPlans; else showCreatePlan">
    <app-list-plans (showCreatePlan)="showForm($event)" (showUpdatePlan)="updatePlan($event)"></app-list-plans>
  </ng-container>
  <ng-template #showCreatePlan>
    <app-create-plan [getIdPlan]="id_plan"></app-create-plan>
  </ng-template>
  </div>
  
